<div>
    <img src="../../assets/angular.png" width="50">
</div>
<h1>Welcome!</h1>

<p>
    <a routerLink="/invoices">Invoices</a>
</p>
<p>
    <a routerLink="/payment-history">Payment History</a>
</p>